import React, { useContext, useEffect, useState } from "react";
import "chartjs-adapter-date-fns";
import { BiReset } from "react-icons/bi";
import { apiGet, apiPut } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import OCountUp from "components/OCountUp";
import helpers from "utils/helpers";
import { NavLink } from "react-router-dom";
import { startCase } from "lodash";
import SubCategory from "../assets/images/subcategory.png";
import Earning from "../assets/images/earning_manager.png";
import { AnimatePresence, motion } from "framer-motion";
import AnimatedComponent from "components/reusable/AnimatedComponent";
import JobStatusCard from "components/JobStatusCard";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import {
  MdDesignServices,
  MdGeneratingTokens,
  MdOutlineIncompleteCircle,
} from "react-icons/md";
import { v4 as uuidv4 } from "uuid";

const chartData = [
  { color: "#4F46E5" },
  { color: "#6366F1" },
  { color: "#A5B4FC" },
  { color: "#DBEAFE" },
];

function Home() {
  const { t } = useTranslation();
  const { logoutUser, user } = useContext(AuthContext);
  const [dashboardDetails, setDashboardDetails] = useState({});

  let pieChartData =
    dashboardDetails?.serviceDistributionData?.graphData?.map((res, index) => ({
      ...res,
      color: chartData?.[index]?.color,
    })) || [];

  const [filterData, setFilterData] = useState({
    startDate: "",
    status: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });

  const manager =
    user?.permission?.find((e) => e.manager === "dashboard") ?? {};

  const getDashboardDetails = async () => {
    try {
      const payload = {
        startDate: helpers?.ternaryCondition(
          filterData?.startDate,
          dayjs(filterData?.startDate).format("YYYY-MM-DD"),
          null
        ),
        endDate: helpers?.ternaryCondition(
          filterData?.endDate,
          dayjs(filterData?.endDate).format("YYYY-MM-DD"),
          null
        ),
        filterType: filterData?.status,
      };
      const path = pathObj.getDashboardDetails;
      const result = await apiGet(path, payload);
      setDashboardDetails({ ...dashboardDetails, ...result.data.results });
    } catch (error) {
      console.error("error:", error);
      
    }
  };

  useEffect(() => {
    getDashboardDetails();
    const interval = setInterval(() => {
      getDashboardDetails();
    }, 10000);

    return () => clearInterval(interval);
  }, [filterData]);

  const handleResetDashboard = () => {
    setFilterData({
      startDate: "",
      status: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
  };

  const handleDashboardDateChange = (start, end) => {
    setFilterData({
      ...filterData,
      startDate: start,
      status: "",
      endDate: end,
      isFilter: true,
      isReset: false,
    });
  };

  if (helpers.andOperator(user?.role == "subAdmin", !manager?.view)) {
    return (
      <div
        className="flex justify-center items-center"
        style={{ height: "700px" }}
      >
        <div className="text-center">
          <div className="text-[26px]" style={{ fontWeight: 500 }}>
            <h3>
              Welcome!{" "}
              {`${startCase(user?.firstName)} ${startCase(user?.lastName)}`} You
              Are Not Authorize To View This Page
            </h3>
          </div>
          <div className="text-[20px] mt-1" style={{ fontWeight: 400 }}>
            <p>Sorry for the inconvenience.</p>
          </div>
        </div>
      </div>
    );
  }
  const handleStatusToggle = (e) => {
    e.preventDefault();
    const newStatus = !dashboardDetails?.isOnline;

    helpers.alertFunction(
      `Are you sure you want to change the status ?`,
      dashboardDetails,
      () => handleUpdateStatus(newStatus),
      null
    );
  };

  const handleUpdateStatus = async (newStatus) => {
    try {
      const payload = {
        isOnline: newStatus,
      };
      const resp = await apiPut(pathObj.updateAvailability, payload);
      if (resp?.data?.success) {
        console.log("eeererer", resp);

        getDashboardDetails();
        Notification.success(resp?.data?.message);
        return;
      }
    } catch (err) {
      console.error("Error in update status:", err);
    }
  };

  return (
    <>
      <div className="py-4 px-4 md:px-8 dark:bg-slate-900">
        <div className="flex flex-wrap items-center mt-3 mb-3">
          <div className="flex flex-wrap items-center lg:pt-0 pt-3 justify-center">
            <p
              className={`py-2 rounded-xl text-sm text-white px-4 mb-3 ${
                dashboardDetails?.isOnline === false
                  ? "bg-red-500"
                  : "bg-green-500"
              }`}
            >
              {dashboardDetails?.isOnline === false ? "Offline" : "Online"}
            </p>
            <ODateRangePicker
              handleDateChange={handleDashboardDateChange}
              isReset={filterData?.isReset}
              setIsReset={setFilterData}
              filterData={filterData}
            />
            <div className="mb-3 mx-2">
              <select
                id=""
                type="text "
                name="status"
                className="block p-2 text-sm text-[#A5A5A5] bg-transparent border-2 dark:border-[#fff] rounded-lg border-[#DFDFDF]  dark:text-[#A5A5A5] dark:border-gray-600"
                placeholder=" "
                value={filterData?.status}
                onChange={(e) => {
                  setFilterData({
                    startDate: "",
                    endDate: "",
                    status: e?.target?.value,
                  });
                }}
              >
                <option defaultValue value="">
                  {t("FILTER_TYPE")}
                </option>
                <option value="daily">{t("O_DAILY")}</option>
                <option value="weekly">{t("O_WEEKLY")}</option>
                <option value="monthly">{t("O_MONTHLY")}</option>
              </select>
            </div>

            <button
              type="button"
              onClick={() => handleResetDashboard()}
              className="bg-gradientTo text-sm px-6 flex gap-2 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
              title={t("O_RESET")}
            >
              <BiReset size={18} /> {t("O_RESET")}
            </button>
            <div className="flex items-center mb-3 ml-3">
              <label className="inline-flex relative items-center cursor-pointer group">
                <input
                  type="checkbox"
                  id="statusToggle"
                  className="sr-only peer"
                  checked={dashboardDetails?.isOnline === false ? false : true}
                  onChange={handleStatusToggle}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-500"></div>
                <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 px-2 py-1 text-xs rounded bg-black text-white opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap">
                  {dashboardDetails?.isOnline ? "Online" : "Offline"}
                </span>
              </label>
            </div>
          </div>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={"empty"}
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="sale_report grid pt-10 3xl:grid-cols-4 gap-y-10 gap-4 gap-x-10 2xl:grid-cols-4 sm:grid-cols-2 mb-7">
              <motion.div
                className=""
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="bg-[#fafafb] rounded-lg shadow-lg p-4">
                  <NavLink to="/earning-manager" state={filterData}>
                    <div className="flex justify-between items-center mb-2">
                      <h2 className="text-lg font-semibold text-gray-800">
                        {t("TOTAL_REVENUE")}
                      </h2>
                      <span className="text-gray-400 filter brightness-0">
                        <img src={Earning} alt="" />
                      </span>
                    </div>
                    <p className="text-3xl font-bold text-gray-900">
                      {" "}
                      {helpers.formattedAmount(
                        dashboardDetails?.totalEarnings || 0
                      )}
                    </p>
                  </NavLink>
                </div>
              </motion.div>

              <motion.div
                className=""
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="bg-[#fafafb] rounded-lg shadow-lg p-4">
                  <NavLink to="/earning-manager" state={filterData}>
                    <div className="flex justify-between items-center mb-2">
                      <h2 className="text-lg font-semibold text-gray-800">
                        {t("TOTAL_TIP")}
                      </h2>
                      <span className="text-gray-400 filter brightness-0">
                        <img src={Earning} alt="" />
                      </span>
                    </div>
                    <p className="text-3xl font-bold text-gray-900">
                      {" "}
                      {helpers.formattedAmount(
                        dashboardDetails?.totalTips || 0
                      )}
                    </p>
                  </NavLink>
                </div>
              </motion.div>

              <motion.div
                className=""
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="bg-[#fafafb] rounded-lg shadow-lg p-4">
                  {/* <Link to="/earning-manager"> */}
                  <div className="flex justify-between items-center mb-2">
                    <h2 className="text-lg font-semibold text-gray-800">
                      {t("ACCEPTION_RATE")}
                    </h2>
                    <span className="text-gray-400 filter brightness-0">
                      <MdOutlineIncompleteCircle size={20} />
                    </span>
                  </div>
                  <p className="text-3xl font-bold text-gray-900">
                    {" "}
                    {dashboardDetails?.acceptanceRate?.toFixed(2) || 0}%
                  </p>
                  {/* </Link> */}
                </div>
              </motion.div>

              <motion.div
                className=""
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="bg-[#fafafb] rounded-lg shadow-lg p-4">
                  <NavLink to="/feedback-manager" state={filterData}>
                    <div className="flex justify-between items-center mb-2">
                      <h2 className="text-lg font-semibold text-gray-800">
                        {t("AVERAGE_RATING")}
                      </h2>
                      <MdGeneratingTokens size={27} />
                    </div>
                    <div className="flex">
                      <p className="text-3xl font-bold text-gray-900">
                        {" "}
                        {dashboardDetails?.averageRating?.toFixed(2) || 0}/5.00
                      </p>
                      <span className="text-yellow-400 text-2xl ml-2 mt-[2px]">
                        ★
                      </span>
                    </div>
                  </NavLink>
                </div>
              </motion.div>

              <motion.div
                className=""
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="bg-[#fafafb] rounded-lg shadow-lg p-4 w-full">
                  {/* <NavLink to="/" state={filterData}> */}
                    <div className="flex justify-between items-center mb-2">
                      <h2 className="text-lg font-semibold text-gray-800">
                        {t("TOTAL_SERVICE")}
                      </h2>
                      <MdDesignServices className="text-gray-400 text-2xl filter brightness-0" />
                    </div>
                    <p className="text-3xl font-bold text-gray-900">
                      <OCountUp value={dashboardDetails?.totalService} />
                    </p>
                  {/* </NavLink> */}
                </div>
              </motion.div>

              <motion.div
                className=""
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="bg-[#fafafb] rounded-lg shadow-lg p-4 w-full">
                  <NavLink to="/driver-manager" state={filterData}>
                    <div className="flex justify-between items-center mb-2">
                      <h2 className="text-lg font-semibold text-gray-800">
                        {t("TOTAL_NUMBER_OF_DRIVERS")}
                      </h2>
                      <span className="text-gray-400 text-2xl filter brightness-0">
                        <img src={SubCategory} alt="" />
                      </span>
                    </div>
                    <p className="text-3xl font-bold text-gray-900">
                      <OCountUp value={dashboardDetails?.totalDrivers} />
                    </p>
                  </NavLink>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="grid 3xl:grid-cols-3 gap-y-10 gap-4 gap-x-10 2xl:grid-cols-3 sm:grid-cols-2 ">
          <JobStatusCard dashboardDetails={dashboardDetails?.totalJobs} />
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
            }}
            whileTap={{ scale: 0.95 }}
            className="transition-all rounded-lg bg-[#fafafb] shadow-lg  w-full max-w-lg"
          >
            <div className="px-5 mt-4">
              <h3 className="text-md text-gray-700 mb-1 font-bold">
                {" "}
                {t("SERVICE_DISTRIBUTION")}
              </h3>
              <div className="text-3xl font-bold text-gray-800 mb-3 flex items-center justify-center sm:justify-start gap-1 mt-4"></div>
            </div>
            {helpers?.ternaryCondition(
              pieChartData?.length > 0,
              <motion.div
                whileHover={{ scale: 1.03 }}
                className="flex flex-col sm:flex-row items-center justify-end sm:gap-4 px-5 py-3 w-full  transition-all"
              >
                <div className="w-[80%] h-40 flex items-center justify-center">
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Tooltip content={<CustomTooltip />} />
                      <Pie
                        data={pieChartData}
                        cx="48%"
                        cy="50%"
                        innerRadius={40}
                        outerRadius={75}
                        paddingAngle={2}
                        dataKey="value"
                      >
                        {pieChartData?.map((item, index) => (
                          <Cell key={uuidv4()} fill={item?.color} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="text-center sm:text-left sm:w-1/2 w-full">
                  <div className="space-y-1 text-sm">
                    {pieChartData?.map((item) => (
                      <div
                        key={uuidv4()}
                        className="mx- flex items-center gap-2 text-gray-700 py-1"
                      >
                        <span
                          className="w-3 h-3 rounded-sm inline-block"
                          style={{ backgroundColor: item?.color }}
                        ></span>
                        <span>
                          {startCase(item?.name)} (
                          {helpers.orOperator(item?.value?.toFixed(2), 0)}%)
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </motion.div>,
              <div className="flex justify-center h-40 items-center">
                {t("O_NO_RECORD_FOUND")}
              </div>
            )}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
            }}
            whileTap={{ scale: 0.95 }}
            className="transition-all rounded-lg bg-[#fafafb] shadow-lg w-full max-w-lg"
          >
            <div className="px-5 mt-4">
              <h3 className="text-md text-gray-700 mb-1 font-bold">
                {t("RESPONSE_TIME")}
              </h3>
              <div className="text-3xl font-bold text-gray-800 mb-3 flex items-center justify-center sm:justify-start gap-1 mt-4">
                {helpers.orOperator(dashboardDetails?.responseTime?.minutes, 0)}m
                :
                {helpers.orOperator(dashboardDetails?.responseTime?.seconds, 0)}
                <span className="text-2xl">s</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <AnimatedComponent></AnimatedComponent>
    </>
  );
}

export default Home;

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white shadow px-2 py-1 text-sm border border-gray-200 rounded">
        {startCase(payload?.[0]?.name)}: <strong>{payload?.[0]?.value}%</strong>
      </div>
    );
  }
  return null;
};
